import {
  Waves, Hammer, Zap, Flame, Droplets, ArrowDownToLine, Video, AlarmClock,
  ArrowUpRight, Wrench, ArrowUp, PlugZap, Building2, Droplet, FlaskConical,
  ArrowDownUp, CircleDot, Gauge, Trash2, Wind, Home, WashingMachine,
} from "lucide-react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FEATURED_SERVICES, SERVICES } from "@/data/services";
import { Reveal, Stagger, StaggerItem } from "@/components/motion/Reveal";

const ICONS = {
  Waves, Hammer, Zap, Flame, Droplets, ArrowDownToLine, Video, AlarmClock,
  Wrench, ArrowUp, PlugZap, Building2, Droplet, FlaskConical, ArrowDownUp,
  CircleDot, Gauge, Trash2, WashingMachine, Wind, Home,
};

export default function ServicesGrid({ services = FEATURED_SERVICES, showViewAll = true, city }) {
  const list = services;
  return (
    <section id="services" className="bg-white border-y border-slate-200">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-20 md:py-28">
        <Reveal className="grid md:grid-cols-12 gap-8 md:gap-12 items-end mb-12">
          <div className="md:col-span-7">
            <div className="flex items-baseline gap-3">
              <span className="font-display font-black text-sm text-[#A88852]">01 —</span>
              <div className="label-eyebrow">What we do</div>
            </div>
            <h2 className="font-display text-4xl md:text-5xl font-black tracking-tight mt-2 text-slate-900">
              Every service. <span className="text-orange-500">One call.</span>
            </h2>
          </div>
          <p className="md:col-span-5 text-slate-600 md:text-lg">
            From a slow drain to a full sewer line replacement, water heater install to reverse osmosis — our expert plumbers handle it all with upfront pricing.
          </p>
        </Reveal>

        <Stagger stagger={0.05} className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-slate-200 border border-slate-200 rounded-md overflow-hidden">
          {list.map((svc) => {
            const Icon = ICONS[svc.icon] || Wrench;
            const href = city ? `/service-areas/${city.slug}/${svc.slug}` : "#quote";
            const Wrapper = city ? Link : "a";
            const wrapperProps = city ? { to: href } : { href: "#quote" };
            return (
              <StaggerItem key={svc.slug} className="bg-white">
                <Wrapper
                  {...wrapperProps}
                  data-testid={`service-card-${svc.slug}`}
                  className="svc-card group bg-white p-7 flex flex-col gap-4 min-h-[210px] h-full"
                >
                  <div className="w-11 h-11 bg-[#1E3A5F] grid place-items-center text-[#D9BF8C] rounded-sm">
                    <Icon size={22} />
                  </div>
                  <div className="flex-1">
                    <h3 className="font-display text-xl font-bold text-slate-900 tracking-tight">
                      {svc.title}
                    </h3>
                    <p className="text-sm text-slate-600 mt-2 leading-relaxed">{svc.blurb}</p>
                  </div>
                  <div className="flex items-center gap-1.5 text-orange-600 font-semibold text-sm group-hover:gap-2.5 transition-all">
                    Schedule appointment <ArrowUpRight size={14} />
                  </div>
                </Wrapper>
              </StaggerItem>
            );
          })}
        </Stagger>

        {showViewAll && (
          <Reveal delay={0.1} className="mt-8 flex flex-wrap gap-6 items-center justify-between">
            <p className="text-sm text-slate-500">
              Peak Plumbing offers {SERVICES.length}+ dedicated plumbing services — from faucet replacement to well pumps.
            </p>
            <Link
              to="/services"
              data-testid="view-all-services"
              className="btn-outline-dark inline-flex items-center gap-1.5 px-4 py-2 text-sm"
            >
              View All {SERVICES.length} Services <ArrowUpRight size={14} />
            </Link>
          </Reveal>
        )}
      </div>
    </section>
  );
}
